<template>
    <v-container style="min-width:100%;" class="pr-8 pl-0">
        <v-row class="mr-1 ml-1">
            <v-card style="background-color:antiquewhite; width:100%; margin-top:30px;height: 50px;align-content:center; border: 2px ridge saddlebrown;">
                <v-row style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 20px;">
                    <div v-for="(score, index) in ['strength', 'dexterity', 'constitution', 'intelligence', 'wisdom', 'charisma']" v-bind:key="score" style="text-align:center; font-size:20px; flex: 1; display: flex; align-items: center; justify-content: center; position: relative; font-weight:bold;">
                        {{ score.charAt(0).toUpperCase() + score.slice(1) }}: {{ character.characterData.abilities[score].modifiedScore - character.characterData.abilities[score].bonus }}
                        <div v-if="index < 5" style="position: absolute; right: -10px; width: 2px; height: 30px; background-color: rgba(0,0,0,0.75);"></div>
                    </div>
                </v-row>
            </v-card>
            <v-card style="background-color:antiquewhite; width:100%; margin-top:12px;margin-bottom:24px; height: 50px;align-content:center; border: 2px ridge saddlebrown;">
                <v-row style="display: flex; align-items: center; justify-content: space-between; height: 100%; padding: 0 20px;">
                    <div v-for="(emotion, index) in sortedEmotionalArray" v-bind:key="emotion.name" style="text-align:center; font-size:20px; flex: 1; display: flex; align-items: center; justify-content: center; position: relative; font-weight:bold;">
                        {{ emotion.name }}: <span v-if="character.psyche.emotionalArray[emotion.name] > 0"> +</span> {{ character.psyche.emotionalArray[emotion.name] }}
                        <div v-if="index < 6" style="position: absolute; right: -10px; width: 2px; height: 30px; background-color: rgba(0,0,0,0.75);"></div>
                    </div>
                </v-row>
            </v-card>
            <v-col cols="12" style="text-align:center; font-size:30px;margin-top:20px;color:saddlebrown; justify-items: center;">
                                 <v-row style="align-items:center; position: relative;">
                     <v-img :src="require(`../../assets/name_frame_mid_ready.png`)" style="width:350px; align-items:center" contain>
                        <div style="color:antiquewhite;text-align:center;justify-content:center;">Total Soul: {{ totalSoul - character.psyche.soulDamage }}/{{ totalSoul }}</div>
                    </v-img>
                    <v-text-field v-model="tempSoul" style="font-size:30px; max-width:50px; text-align-last:center!important; justify-self: center!important; margin-bottom:14px; margin-top:14px;" class="centered-input-brown" hide-details="true" dense @focus="tempTracker = character.psyche.soulDamage; tempSoul = ''" @blur="tempSoul = 0"  @keyup.enter="doSoulTrackerMath" @change="checkSoulChange"></v-text-field>

                    
                    <v-menu offset-y nudge-left="60">
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn
                          icon
                          v-bind="attrs"
                          v-on="on"
                          style="color:gray; position:absolute; right:48px; top:-25px; z-index:1;"
                          @click="shouldShowAdmin($event)"
                          >
                          <v-icon style="font-size:32px; color:rgb(69,69,69);">settings</v-icon>
                          </v-btn>
                      </template>
                      
                      <v-list>
                          <v-list-item @click="resetDuel">
                              <v-list-item-title>New Duel</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="shortRest">
                              <v-list-item-title>Short Rest</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="restlessNight">
                              <v-list-item-title>Restless Night</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="fullRest">
                              <v-list-item-title>Full Rest</v-list-item-title>
                          </v-list-item>
                      </v-list>
                  </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" v-for="pillar in pillars" v-bind:key="pillar.name">
                <v-card-title class="brown darken-4 pt-5" style="color:antiquewhite; margin-bottom:6px; justify-content:center; font-size:42px; border-top-left-radius:6px; border-top-right-radius:6px; border: 2px ridge rgb(0,0,0,1); z-index: 1; position: relative; text-shadow: 2px 2px 2px rgba(0,0,0,1), -2px -2px 2px rgba(0,0,0,1), 2px -2px 2px rgba(0,0,0,1), -2px 2px 2px rgba(0,0,0,1);">{{ pillar.name[0].toUpperCase() + pillar.name.slice(1) }}</v-card-title>
                <v-img :src="require(`../../assets/big_bar_bg.png`)" class="background3" style="margin-top:-10px; border-bottom-left-radius:12px; border-bottom-right-radius:12px; border: 2px ridge rgb(0,0,0,0.75); border-top:none;">
                    <v-card  class="ma-2 py-4 pb-1 pb-5 box-shadow" v-for="aspect in pillar.aspects" v-bind:key="aspect.name" :style="`background-color:rgba(10,10,10,0.1); ${isShattered(aspect) ? 'border: 2px solid red;' : isCracked(aspect) ? 'border: 2px solid rgb(191, 87, 0);' : 'border: 2px solid rgb(69, 69, 69, 1);'}`">
                        <v-card-title :style="`justify-content:center; font-size:30px; color:${isShattered(aspect) ? 'red' : isCracked(aspect) ? '#FF8C00' : 'antiquewhite'}`" :class="`pb-2 ${isCracked(aspect) ? 'shield-text' : ''}`">{{ aspect.name[0].toUpperCase() + aspect.name.slice(1) }}</v-card-title> 
                        <span v-if="isCracked(aspect)" style="color:rgb(255, 103, 0); position:absolute; top:8px; right:10px; font-style:italic">Cracked!</span> 
                        <span v-if="isShattered(aspect)" style="color:red; position:absolute; top:8px; right:10px; font-style:italic">Shattered!</span>
                        <v-divider class="mb-4 mx-4" style="border-top-width: 2px; border-top-color:rgb(250, 235, 215, 0.24);"></v-divider>
                        <v-img :src="getShieldImage(aspect)" :class="getShieldGlowClass(aspect) + ' not-background3'" style="height:125px; transition: opacity 0.2s ease-in-out;" contain>
                            <!-- <v-img v-if="aspect.scores[0].cracked || aspect.scores[1].cracked" :src="require(`../assets/cracked.png`)" style="width:100%; height:100%; position:absolute; top:0; left:0; opacity:0.6"></v-img> -->
                            <!-- <v-img v-if="aspect.scores[0].cracked && aspect.scores[1].cracked" :src="require(`../assets/shattered1.png`)" style="width:100%; height:100%; position:absolute; top:0; left:0; opacity:0.4"></v-img> -->
                            <v-row style="height:100%;">
                                 <v-col cols="12" style="text-align:center; font-size:25px;margin-top:20px;color:white;">
                                     <h3 class="shield-text">{{ aspect.scores[0].name[0].toUpperCase() + aspect.scores[0].name.slice(1) }}: <span v-if="getModifier(aspect.scores[0].name, pillar, aspect) >= 0">+</span>{{ getModifier(aspect.scores[0].name, pillar, aspect) }}</h3>
                                     <div class="shield-text" style="font-size:30px; margin-top:-2px;">{{ getScore(aspect.scores[1].name)-aspect.scores[1].damage }} <span style="white-space:nowrap;">/ {{ getScore(aspect.scores[1].name) }}</span></div>
                                 </v-col>
                                 <v-col>
                                     <br/><br/><h3 class="shield-text">{{ aspect.scores[1].name[0].toUpperCase() + aspect.scores[1].name.slice(1) }}:</h3>
                                 </v-col>
                             </v-row>
                        </v-img>
                        
                        <v-row style="justify-self: center;">
                            <v-col cols="12" style="align-content:center; justify-content: center; text-align: center;">
                                <v-text-field v-model="aspect.temp" style="font-size:24px; max-width:50px; text-align-last:center!important; justify-self: center!important;" class="centered-input" hide-details="true" dense @focus="tempTracker = aspect.scores[1].damage; aspect.temp = ''" @blur="aspect.temp = 0"  @keyup.enter="doTrackerMath(aspect)" @change="checkChange(aspect)"></v-text-field>
                                <div style="position: relative; display: flex; flex-direction: column; align-items: center;">
                                    <v-btn style="margin-top:8px; color:white; background-color:rgb(66, 66, 66); border: 6px outset rgb(0, 0, 0, 0.75);" @click="flip(aspect, pillar)">flip</v-btn>
                                    <v-icon large style=" margin-top:2px;color: white; text-shadow: 2px 2px 4px rgba(0,0,0,1), -2px -2px 4px rgba(0,0,0,1), 2px -2px 4px rgba(0,0,0,1), -2px 2px 4px rgba(0,0,0,1); filter: drop-shadow(0 0 3px rgba(0,0,0,0.8));">sync</v-icon>
                                    <div style="background-color:silver; color:black; border: 4px ridge black;font-size:14px; text-align: center; white-space: nowrap;margin-top:2px;margin-bottom:-12px; padding: 4px 4px;">{{ aspect.scores[1].name[0].toUpperCase() + aspect.scores[1].name.slice(1) }}: (<span v-if="getModifier(aspect.scores[1].name, pillar, aspect) >= 0">+</span>{{ getModifier(aspect.scores[1].name, pillar, aspect) }}) {{ getScore(aspect.scores[0].name)-aspect.scores[0].damage }}/{{ getScore(aspect.scores[0].name) }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-img>
            </v-col>
        </v-row>
          <v-row style="justify-content:center;">
            <h1 style="margin-bottom:0px;margin-top:32px; font-size:42px; ">Spirit:</h1>
          </v-row>
          <v-row style="margin-top:-18px;">
              <v-col cols="4" v-for="aspect in spirit.aspects" v-bind:key="aspect.name" style="text-align:center; font-size:30px;margin-top:0px;color:white;">
              <v-img :src="require(`../../assets/Background_blue.png`)" style="margin-top:-10px; border-radius:12px; border: 2px ridge rgb(0,0,0,0.75); border-top:none; height:300px; margin-top:16px; border-style:ridge; border-color:rgb(69,69,69); border-width:4px;">
                <v-card style="background-color:transparent;" flat class=" py-2 pb-1 pb-5">
                    <v-card-title style="justify-content:center; font-size:30px; color:rgb(144,144,144); text-shadow: 1px 1px 1px rgba(30,30,30,1), -1px -1px 1px rgba(30,30,30,1), 1px -1px 1px rgba(30,30,30,1), -1px 1px 1px rgba(30,30,30,1);" class="pb-2">{{ aspect.name[0].toUpperCase() + aspect.name.slice(1) }}</v-card-title>
                    <v-divider class="mb-4" style="border-top-width: 2px; border-top-color:rgb(144,144,144,0.3);"></v-divider>
                    <v-card-text>
                        <div style="font-size:30px; color:rgb(144,144,144); font-weight:bold; text-shadow: 1px 1px 1px rgba(30,30,30,1), -1px -1px 1px rgba(30,30,30,1), 1px -1px 1px rgba(30,30,30,1), -1px 1px 1px rgba(30,30,30,1);">{{ getScore(getScoreName(aspect.scores[0])) + getScore(getScoreName(aspect.scores[1])) + (parseInt(aspect.scoreModifier) || 0) - (aspect.damage || 0)}} / {{ getScore(getScoreName(aspect.scores[0])) + getScore(getScoreName(aspect.scores[1])) + (parseInt(aspect.scoreModifier) || 0) }}</div>
                        <v-text-field v-model="aspect.temp" style="font-size:24px; max-width:50px; text-align-last:center!important; justify-self: center!important; margin-bottom:14px; margin-top:14px;" class="centered-input-dark" hide-details="true" dense @focus="tempTracker = aspect.damage; aspect.temp = ''" @blur="aspect.temp = 0"  @keyup.enter="doSpiritTrackerMath(aspect)" @change="checkChange(aspect)"></v-text-field>
                        <v-btn style="color:silver; background-color:rgb(69,69,69); border: 4px outset rgb(144,144,144); padding-top:3px;" @click="aspect.expended = aspect.expended+1 > character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier ? character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier : aspect.expended+1">Use</v-btn>
                        <div style="margin-top:6px; color:rgb(144,144,144);">Uses: {{ character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier - (aspect.expended || 0) }}/{{ character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier }}</div>
                        <v-row style="justify-content:center;">
                          <div 
                              v-for="circleIndex in Math.max(0, character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier)" 
                              :key="circleIndex"
                              :style="`
                                  width: 20px;
                                  height: 20px;
                                  border-radius: 50%;
                                  border: 2px outset rgb(144,144,144);
                                  background-color: ${circleIndex <= (character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier - (aspect.expended || 0)) ? 'rgb(144,144,144)' : 'transparent'};
                                  cursor: pointer;
                                  transition: background-color 0.2s;
                                  margin-left: 2px;
                                  margin-right: 2px;
                                  margin-bottom: 0px;
                                  margin-top: 16px;
                              `"
                              @click="aspect.expended = character.characterData.abilities[getScoreName(aspect.scores[0])].modifiedModifier + (parseInt(aspect.modifier) || 0) + character.characterData.abilities[getScoreName(aspect.scores[1])].modifiedModifier - circleIndex"
                          ></div>
                        </v-row>
                    </v-card-text>
                    </v-card>
                  </v-img>
              </v-col>
          </v-row>
          <v-dialog v-model="showAdmin" max-width="1200">
            <v-card>
                <v-card-title class="headline brown darken-4" style="color:antiquewhite;">
                    <v-tabs v-model="adminTab" background-color="brown darken-5" dark align-tabs="center" fixed-tabs>
                        <v-tab>Aspect Modifiers</v-tab>
                        <v-tab>Emotional Array</v-tab>
                        <v-tab>Powers</v-tab>
                    </v-tabs>
                </v-card-title>
                <v-card-text style="margin-top:16px;color:black!important">
                    <v-tabs-items v-model="adminTab" style="background-color:transparent; width:100%; padding-left:16px; padding-bottom:16px;">
                        <!-- Aspect Modifiers Tab -->
                        <v-tab-item>
                            <div class="text-h6 mb-4">Modify Aspect Modifiers</div>
                            
                            <!-- Pillar Aspects -->
                            <div v-for="pillar in pillars" :key="pillar.name" class="mb-6">
                                <div class="text-h5 mb-3" style="color: #654321; font-weight: bold;">{{ pillar.name.charAt(0).toUpperCase() + pillar.name.slice(1) }} Pillar</div>
                                <v-row>
                                    <v-col cols="4" v-for="aspect in pillar.aspects" :key="aspect.name">
                                        <v-card outlined class="pa-3">
                                            <div class="text-h6 mb-2">{{ aspect.name.charAt(0).toUpperCase() + aspect.name.slice(1) }}</div>
                                            <v-text-field
                                                v-model="aspect.modifier"
                                                label="Modifier"
                                                type="number"
                                                dense
                                                outlined
                                                hide-details
                                                style="max-width: 100px;"
                                            ></v-text-field>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                            
                                                         <!-- Spirit Aspects -->
                             <div class="mb-6">
                                 <div class="text-h5 mb-3" style="color: #654321; font-weight: bold;">Spirit Aspects</div>
                                 <v-row>
                                     <v-col cols="12" md="4" v-for="aspect in spirit.aspects" :key="aspect.name">
                                         <v-card outlined class="pa-3">
                                             <div class="text-h6 mb-2">{{ aspect.name.charAt(0).toUpperCase() + aspect.name.slice(1) }}</div>
                                             <v-row>
                                                 <v-col cols="6">
                                                     <v-text-field
                                                         v-model="aspect.modifier"
                                                         label="Modifier"
                                                         type="number"
                                                         dense
                                                         outlined
                                                         hide-details
                                                         style="max-width: 100px;"
                                                     ></v-text-field>
                                                 </v-col>
                                                 <v-col cols="6">
                                                     <v-text-field
                                                         v-model="aspect.scoreModifier"
                                                         label="Score Modifier"
                                                         type="number"
                                                         dense
                                                         outlined
                                                         hide-details
                                                         style="max-width: 100px;"
                                                     ></v-text-field>
                                                 </v-col>
                                             </v-row>
                                         </v-card>
                                     </v-col>
                                 </v-row>
                                                          </div>
                         </v-tab-item>
                         
                         <!-- Emotional Array Tab -->
                         <v-tab-item>
                             <div class="text-h6 mb-4">Modify Emotional Array</div>
                             
                             <v-card outlined class="pa-4">
                                 <div class="text-subtitle-1 mb-3">Adjust emotional modifier values:</div>
                                 <v-row>
                                     <v-col cols="3" v-for="emotion in ['Apathy', 'Happiness', 'Fear', 'Anger', 'Disgust', 'Sadness', 'Awe']" :key="emotion">
                                         <v-card outlined class="pa-3">
                                             <div class="text-h6 mb-2">{{ emotion }}</div>
                                             <v-text-field
                                                 v-model="character.psyche.emotionalArray[emotion]"
                                                 label="Modifier"
                                                 type="number"
                                                 dense
                                                 outlined
                                                 hide-details
                                                 style="max-width: 100px;"
                                             ></v-text-field>
                                         </v-card>
                                     </v-col>
                                 </v-row>
                             </v-card>
                         </v-tab-item>
                         
                         <!-- Powers Tab -->
                        <v-tab-item>
                            <div class="text-h6 mb-4">Manage Powers</div>
                            
                            <!-- Add New Power -->
                            <v-card outlined class="pa-4 mb-4">
                                <div class="text-h6 mb-3">Add Power</div>
                                <v-row>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="powerSearch"
                                            label="Search for power"
                                            outlined
                                            dense
                                            @input="filterPowers"
                                            placeholder="Type to search powers..."
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn 
                                            color="primary" 
                                            @click="addPower" 
                                            :disabled="!selectedPower"
                                            block
                                        >
                                            Add Power
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                
                                <!-- Power Search Results -->
                                <div v-if="filteredPowers.length > 0" class="mt-3">
                                    <div class="text-subtitle-1 mb-2">Available Powers:</div>
                                    <v-list dense max-height="200" style="overflow-y: auto;">
                                        <v-list-item 
                                            v-for="power in filteredPowers" 
                                            :key="power.name + power.aspect"
                                            @click="selectPower(power)"
                                            :class="{ 'selected-power': selectedPower === power }"
                                            style="cursor: pointer;"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>{{ power.name || 'Unnamed Power' }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ power.aspect }} - {{ power.description.substring(0, 100) }}...</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </div>
                            </v-card>
                            
                            <!-- Current Powers -->
                            <v-card outlined class="pa-4">
                                <div class="text-h6 mb-3">Current Powers ({{ character.psyche.powers.length }})</div>
                                <div v-if="character.psyche.powers.length === 0" class="text-center pa-4">
                                    <div class="text-subtitle-1 text-muted">No powers added yet</div>
                                </div>
                                <v-list v-else dense>
                                    <v-list-item 
                                        v-for="(power, index) in character.psyche.powers" 
                                        :key="index"
                                        class="mb-2"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>{{ power.name || 'Unnamed Power' }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ power.aspect }}</v-list-item-subtitle>
                                            <v-list-item-subtitle class="mt-1">{{ power.description }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn 
                                                icon 
                                                small 
                                                color="error" 
                                                @click="removePower(index)"
                                            >
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
          </v-dialog>
    </v-container>
</template>

<script>
import { psychePowers } from './psychePowers.js'

export default {
  props:{
    character: {
        type: Object,
        required: true
    },
  },
  data() {
    return {
        showAdmin: false,
        adminTab: 0,
        tempSoul: 0,
        psyche: this.character.psyche,
        tempTracker:0,
        pillars: this.character.psyche.pillars,
        spirit: this.character.psyche.spirit,
        shieldImages: {
            healthy: require('../../assets/Shield Healthy.png'),
            cracked: require('../../assets/Shield Cracked.png'),
            shattered: require('../../assets/Shield Shattered.png')
        },
        // Preload images to prevent flashing
        preloadedImages: {},
        // Power management
        powerSearch: '',
        filteredPowers: [],
        selectedPower: null,
        allPowers: psychePowers
    };
  },
  methods: {
    shouldShowAdmin(event){
      if(event.ctrlKey && event.shiftKey){
        this.showAdmin = !this.showAdmin;
      }
    },
    getShieldImage(aspect) {
        if (aspect.scores[0].cracked && aspect.scores[1].cracked) {
            return this.shieldImages.shattered;
        } else if (aspect.scores[0].cracked || aspect.scores[1].cracked) {
            return this.shieldImages.cracked;
        } else {
            return this.shieldImages.healthy;
        }
     },
     getShieldGlowClass(aspect) {
         if (aspect.scores[0].cracked && aspect.scores[1].cracked) {
             return 'shield-shattered-glow';
         } else if (aspect.scores[0].cracked || aspect.scores[1].cracked) {
             return 'shield-cracked-glow';
         } else {
             return '';
         }
     },
    getScore(score){
        return parseInt(this.character.characterData.abilities[score].modifiedScore - this.character.characterData.abilities[score].bonus);
    },
    getScoreName(score){
        // Handle both string scores (spirit aspects) and object scores (pillar aspects)
        if (typeof score === 'string') {
            return score;
        } else if (score && typeof score === 'object' && score.name) {
            return score.name;
        }
        return score; // fallback
    },
    flip(aspect,pillar){
        let temp = aspect.scores[0];
        aspect.scores[0] = aspect.scores[1];
        aspect.scores[1] = temp;
        pillar.aspects.splice(0,0)
    },
    doTrackerMath(aspect){
        if(aspect.temp[0] == "+" || aspect.temp[0] == "-"){
            aspect.scores[1].damage = aspect.scores[1].damage - parseInt(aspect.temp)
            aspect.temp = 0;
        }else{
            aspect.scores[1].damage = parseInt(aspect.temp)
            aspect.temp = 0;
        }
        if(isNaN(aspect.scores[1].damage)) aspect.scores[1].damage = parseInt(this.tempTracker)
        this.tempTracker = 0
        aspect.temp = ""
        if(aspect.scores[1].damage >= this.getScore(aspect.scores[1].name)) aspect.scores[0].cracked = true;
        else aspect.scores[0].cracked = false;
        if(aspect.scores[1].damage >= this.getScore(aspect.scores[1].name)) {
            let damage = aspect.scores[1].damage - this.getScore(aspect.scores[1].name);
            this.psyche.soulDamage += damage;
        }
    },
    doSoulTrackerMath(){
        if(this.tempSoul[0] == "+" || this.tempSoul[0] == "-"){
            this.psyche.soulDamage = this.psyche.soulDamage - parseInt(this.tempSoul)
            this.tempSoul = 0;
        }else{
            this.psyche.soulDamage =  this.totalSoul - parseInt(this.tempSoul) 
            this.tempSoul = 0;
        }
        if(isNaN(this.psyche.soulDamage)) this.psyche.soulDamage = parseInt(this.tempTracker)
        this.tempTracker = 0
        this.tempSoul = ""
    },
    doSpiritTrackerMath(aspect){
        if(aspect.temp[0] == "+" || aspect.temp[0] == "-"){
            aspect.damage = (aspect.damage || 0) - parseInt(aspect.temp)
            aspect.temp = 0;
        }else{
            aspect.damage = this.getScore(this.getScoreName(aspect.scores[0])) + this.getScore(this.getScoreName(aspect.scores[1])) + (parseInt(aspect.scoreModifier) || 0) - parseInt(aspect.temp)
            aspect.temp = 0;
        }
        if(isNaN(aspect.damage)) aspect.damage = parseInt(this.tempTracker)
        this.tempTracker = 0
        aspect.temp = ""
    },
    checkSoulChange(){
      if(this.tempSoul.length == 0){
        this.tempSoul = parseInt(this.tempTracker);
        this.tempTracker = 0;
      }
    },
    checkChange(aspect){
        if(aspect.temp.length == 0){
            aspect.temp = parseInt(this.tempTracker)
            this.tempTracker = 0
        }
    },
    getModifier(score, pillar, aspect){
        let modifier = Math.floor((this.getScore(score)-10)/2) + parseInt(aspect.modifier)
        pillar.aspects.forEach(aspect => {
            if(aspect.scores[0].cracked) modifier -= 1;
            if(aspect.scores[1].cracked) modifier -= 1;
            if(aspect.scores[1].cracked && aspect.scores[0].cracked) modifier -= 1;
        });
        this.pillars.forEach(p => {
            if(p.name === pillar.name) return;
            p.aspects.forEach(a => {
                a.scores.forEach(s => {
                    if(s.name === score && s.cracked) modifier -= 2;
                });
            });
        });
        return modifier;
    },
    resetDuel(){
        this.pillars.forEach(p => {
            p.aspects.forEach(a => {              
                a.scores.forEach(s => {
                  if(s.damage > this.getScore(s.name)) s.damage = this.getScore(s.name)-1;
                    s.cracked = false;
                });
            });
        });        
    },

    shortRest(){
        this.pillars.forEach(p => {
            p.aspects.forEach(a => {
                a.scores.forEach(s => {
                    s.cracked = false;
                    if(s.damage > this.getScore(s.name)) s.damage = this.getScore(s.name)-1;
                    s.damage -= this.character.characterData.abilities[s.name].modifiedModifier - this.character.characterData.abilities[s.name].bonus;
                });
            });
        });
        this.character.psyche.soulDamage = 0
        this.spirit.aspects.forEach(a => {
            a.expended -= a.expended;
            a.damage -= Math.max(this.getScore(this.getScoreName(a.scores[0])), this.getScore(this.getScoreName(a.scores[1])));
        });
    },

    restlessNight(){
        this.pillars.forEach(p => {
            p.aspects.forEach(a => {
                a.scores.forEach(s => {
                    s.cracked = false;
                    s.damage = 0;
                });
            });
        });
        this.character.psyche.soulDamage = 0
        this.spirit.aspects.forEach(a => {
            a.expended = 0;
            a.damage = 0;
        });
    },

    fullRest(){
        this.pillars.forEach(p => {
            p.aspects.forEach(a => {
                a.scores.forEach(s => {
                    s.cracked = false;
                    s.damage = 0;
                });
            });
        });
        this.character.psyche.soulDamage = 0
        this.spirit.aspects.forEach(a => {
            a.expended = 0;
            a.damage = 0;
        });
    },
    isShattered(aspect){
        return aspect.scores[0].cracked && aspect.scores[1].cracked;
    },
         isCracked(aspect){
         return (aspect.scores[0].cracked || aspect.scores[1].cracked) && !(aspect.scores[0].cracked && aspect.scores[1].cracked);
     },
           preloadShieldImages() {
          // Create Image objects to preload the shield images
          const imageNames = ['healthy', 'cracked', 'shattered'];
          imageNames.forEach(name => {
              const img = new Image();
              img.src = this.shieldImages[name];
              this.preloadedImages[name] = img;
          });
      },
      
      // Power management methods
      filterPowers() {
          if (!this.powerSearch.trim()) {
              this.filteredPowers = [];
              return;
          }
          
          const searchTerm = this.powerSearch.toLowerCase();
          this.filteredPowers = this.allPowers.filter(power => {
              const name = (power.name || '').toLowerCase();
              const description = (power.description || '').toLowerCase();
              const aspect = (power.aspect || '').toLowerCase();
              
              return name.includes(searchTerm) || 
                     description.includes(searchTerm) || 
                     aspect.includes(searchTerm);
          }).slice(0, 10); // Limit to 10 results
      },
      
      selectPower(power) {
          this.selectedPower = power;
      },
      
      addPower() {
          if (this.selectedPower) {
              // Check if power already exists
              const exists = this.character.psyche.powers.some(p => 
                  p.name === this.selectedPower.name && 
                  p.aspect === this.selectedPower.aspect
              );
              
              if (!exists) {
                  this.character.psyche.powers.push({...this.selectedPower});
                  this.powerSearch = '';
                  this.filteredPowers = [];
                  this.selectedPower = null;
              } else {
                  // You could add a toast notification here
                  console.log('Power already exists');
              }
          }
      },
      
      removePower(index) {
          this.character.psyche.powers.splice(index, 1);
      }
      },
   mounted() {
     this.preloadShieldImages();
     console.log(this.character.psyche)
   },
       computed:{
      totalSoul(){
          return Object.values(this.character.characterData.abilities).reduce((acc, score) => acc + parseInt(score.modifiedScore - score.bonus), 0);
      },
      sortedEmotionalArray(){
          // Convert the emotionalArray object to an array of {name, value} pairs and sort by value
          return Object.entries(this.character.psyche.emotionalArray)
              .map(([name, value]) => ({ name, value }))
              .sort((a, b) => a.value - b.value);
      }
    }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center !important;
  color: antiquewhite !important;
}

.centered-input >>> .v-input__slot {
  justify-content: center !important;
}

.centered-input >>> .v-text-field__slot {
  text-align: center !important;
}

.centered-input >>> .v-text-field__slot input {
  color: antiquewhite !important;
}

.centered-input >>> .v-input__slot::before {
  border-color: antiquewhite !important;
}

.centered-input >>> .v-input__slot::after {
  border-color: antiquewhite !important;
}

.centered-input >>> .v-text-field__slot::before {
  border-color: antiquewhite !important;
}

.centered-input >>> .v-text-field__slot::after {
  border-color: antiquewhite !important;
}

.centered-input-brown >>> input {
  text-align: center !important;
  color: #654321 !important;
}

.centered-input-brown >>> .v-input__slot {
  justify-content: center !important;
}

.centered-input-brown >>> .v-text-field__slot {
  text-align: center !important;
}

.centered-input-brown >>> .v-text-field__slot input {
  color: #654321 !important;
}

.centered-input-brown >>> .v-input__slot::before {
  border-color: #654321 !important;
}

.centered-input-brown >>> .v-input__slot::after {
  border-color: #654321 !important;
}

.centered-input-brown >>> .v-text-field__slot::before {
  border-color: #654321 !important;
}

.centered-input-brown >>> .v-text-field__slot::after {
  border-color: #654321 !important;
}

.centered-input-dark >>> input {
  text-align: center !important;
  color: #654321 !important;
}

.centered-input-dark >>> .v-input__slot {
  justify-content: center !important;
}

.centered-input-dark >>> .v-text-field__slot {
  text-align: center !important;
}

.centered-input-dark >>> .v-text-field__slot input {
  color: rgb(144,144,144) !important;
}

.centered-input-dark >>> .v-input__slot::before {
  border-color: rgb(144,144,144) !important;
}

.centered-input-dark >>> .v-input__slot::after {
  border-color: rgb(144,144,144) !important;
}

.centered-input-dark >>> .v-text-field__slot::before {
  border-color: rgb(144,144,144) !important;
}

.centered-input-dark >>> .v-text-field__slot::after {
  border-color: rgb(144,144,144) !important;
}

.shield-cracked-glow {
  filter: drop-shadow(0 0 15px rgba(255, 103, 0, 0.8)) drop-shadow(0 0 25px rgba(255, 103, 0, 0.7));
  animation: cracked-pulse 2s ease-in-out infinite alternate;
}

.shield-shattered-glow {
  filter: drop-shadow(0 0 15px rgba(255, 0, 0, 0.8)) drop-shadow(0 0 25px rgba(255, 0, 0, 0.7));
  animation: shattered-pulse 1.5s ease-in-out infinite alternate;
}

/* Ensure smooth image transitions */
.v-img {
  will-change: opacity;
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* Text outline for better readability on shields */
.shield-text {
  text-shadow: 
    -1px -1px 0 #000,  
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000,
    -2px -2px 0 #000,
     2px -2px 0 #000,
    -2px  2px 0 #000,
     2px  2px 0 #000;
  font-weight: bold;
}

@keyframes cracked-pulse {
  0% {
    filter: drop-shadow(0 0 10px rgba(255, 103, 0, 0.6)) drop-shadow(0 0 20px rgba(255, 103, 0, 0.4));
  }
  100% {
    filter: drop-shadow(0 0 20px rgba(255, 103, 0, 0.9)) drop-shadow(0 0 30px rgba(255, 103, 0, 0.7));
  }
}

@keyframes shattered-pulse {
  0% {
    filter: drop-shadow(0 0 10px rgba(255, 0, 0, 0.6)) drop-shadow(0 0 20px rgba(255, 0, 0, 0.4));
  }
  100% {
    filter: drop-shadow(0 0 20px rgba(255, 0, 0, 0.9)) drop-shadow(0 0 30px rgba(255, 0, 0, 0.7));
  }
}
.box-shadow {
  box-shadow: -6px 10px 154px 25px rgba(0,0,0,1) inset!important;
  -webkit-box-shadow: -6px 10px 154px 25px rgba(0,0,0,1) inset!important;
  -moz-box-shadow: -6px 10px 154px 25px rgba(0,0,0,1) inset!important;
}

.background3 >>> .v-image__image{
  background-size: unset !important; 
}
.background3 >>> .not-background .v-image__image{
  background-repeat: no-repeat;
  background-size: cover !important; 
}
.not-background3 >>> .v-image__image{
  background-size: contain !important; 
  background-repeat: no-repeat !important;
}

.selected-power {
  background-color: rgba(25, 118, 210, 0.1) !important;
  border-left: 4px solid #1976d2 !important;
}

.v-list-item.selected-power:hover {
  background-color: rgba(25, 118, 210, 0.2) !important;
}
</style>